<script setup>
  import { ref } from "vue";
  import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
  import { ChevronDown } from "lucide-vue-next";
  import TargetInput from "./TargetInput.vue";

  const props = defineProps({
    fields: { type: Array, required: true },
    label: { type: String, required: true },
    open: { type: Boolean, default: false },
  });

  const isOpen = ref(props.open);
</script>

<template>
  <div>
    <Collapsible v-model:open="isOpen">
      <CollapsibleTrigger
        class="flex w-full items-center justify-between rounded-md py-3 text-sm font-medium transition-colors">
        <span class="heading-title">{{ label }}</span>
        <ChevronDown :class="['w-4 h-4 transition-transform', isOpen && 'rotate-180']" />
      </CollapsibleTrigger>
      <CollapsibleContent class="py-4 space-y-4">
        <div class="flex items-center justify-end mb-4 border-b border-border pb-2">
          <div class="flex gap-4 text-13 font-medium text-foreground">
            <div class="w-20 text-center">Auto</div>
            <div class="w-20 text-center">Manual</div>
          </div>
        </div>
        <TargetInput
          v-for="field in fields"
          :key="field.name"
          :field="field" />
      </CollapsibleContent>
    </Collapsible>
  </div>
</template>
